export const formatDateRange = (start: string, end?: string) => {
  const startDate = new Date(start);
  const endDate = end ? new Date(end) : new Date(start);
  
  if (!end) {
    endDate.setHours(startDate.getHours() + 2);
  }

  const startYear = startDate.toLocaleDateString(undefined, { year: "2-digit" });
  const endYear = endDate.toLocaleDateString(undefined, { year: "2-digit" });

  const startMonth = startDate.toLocaleDateString(undefined, { month: "short" });
  const endMonth = endDate.toLocaleDateString(undefined, { month: "short" });

  const startDay = startDate.toLocaleDateString(undefined, { day: "2-digit" });
  const endDay = endDate.toLocaleDateString(undefined, { day: "2-digit" });

  const startTime = startDate.toLocaleTimeString('en-US', { 
    hour: 'numeric', 
    minute: 'numeric', 
    hour12: true 
  });
  const endTime = endDate.toLocaleTimeString('en-US', { 
    hour: 'numeric', 
    minute: 'numeric', 
    hour12: true 
  });

  return {
    startDate,
    endDate,
    startYear,
    endYear,
    startMonth,
    endMonth,
    startDay,
    endDay,
    timeRange: `${startTime} - ${endTime}`,
    splitYear: startYear !== endYear,
    splitMonth: startMonth !== endMonth,
    sameMonth: startMonth === endMonth && startYear === endYear,
    splitDay: startDay !== endDay
  };
};